import ApiService from '../../services/ApiService.js';
import { LOGIN_STEPS, USER_STATUS } from '../../appContants.js';

/**
 * Handles the reset-password flow:
 * - Submitting a new password with verification code
 * - Resending the verification code
 */
const useResetPassword = ({ email, goToStep, resetAuth, notify }) => {
  const handleResetPasswordSubmit = async (data, resetForm) => {
    await ApiService.forgetPasswordSubmit({ email, ...data });
    notify.success({
      message: 'Password Reset Successfully',
      description: 'Login with your new password to continue.',
    });
    goToStep(LOGIN_STEPS.PASSWORD, { userStatus: USER_STATUS.CONFIRMED });
    resetAuth();
    resetForm({ email, password: '' });
  };

  const handleResendResetCode = async () => {
    await ApiService.forgetPassword(email);
    notify.success({
      message: 'Verification Code Sent',
      description: 'A new reset code has been sent to your email.',
    });
  };

  return {
    handleResetPasswordSubmit,
    handleResendResetCode,
  };
};

export default useResetPassword;
